export const chipTokens = {
  chip: {
    root: {
      borderRadius: '{borderRadius.sm}',
      paddingX: '0.25rem',
      paddingY: '0.1875rem',
      gap: '0.25rem',
      transitionDuration: '{transition.duration}'
    },
    colorScheme: {
      light: {
        root: {
          background: '{highlight.background}',
          color: '{text.color}'
        },
        icon: {
          color: '{primary.color}'
        }
      }
    }
  }
};

export type ChipTokens = typeof chipTokens;
